import { render } from "./IBase.vue?vue&type=template&id=2f51cba6"
import script from "./IBase.vue?vue&type=script&lang=js"
export * from "./IBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__